export default `
fragment ParagraphInformationTags on ParagraphInformationTags {
  id
  uuid
  entityBundle
  title
  description {
    value
  }
  theme {
    entity {
      name
      classes
    }
  }  
  colorPalette {
    entity {
      name
      colors {
        color
      }
    }
  }
  items {
    entity {
      ...ParagraphInformationTag
    }
  }
  button {
    entity {
      ...ParagraphButton
    }
  }
}
`